import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagType } from './feature-flag.params';
import { EFeatureFlags } from '@app/shared/enums/feature-flag';
import { EPermissionKeys } from '@app/shared/enums/permission-keys';
import { FeatureFlagService } from '@app/shared/services/feature-flag/feature-flag.service';
import { PermissionsService } from '@app/shared/services/permissions/permissions.service';

@Directive({
  selector: '[visibility]',
})
export class FeatureFlagDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private featureFlagService: FeatureFlagService,
    private permissionsService: PermissionsService
  ) {}

  @Input() set visibility(config: FeatureFlagType) {
    const permissionResult = config?.permissionKey ? this.checkPermissionStrategy(config.permissionKey) : true;
    const featureFlagResult = config.featureFlag ? this.checkFeatureFlagStrategy(config.featureFlag) : true;

    let navItemsResult = true;
    if (config && config.navItems) {
      const permissionKeys = config?.navItems?.filter((item) => item.permissionKey).map((v) => v.permissionKey) || null;
      if (permissionKeys?.length > 0) {
        navItemsResult = permissionKeys.some((v) => this.permissionsService.evaluate(v));
      }
    }
    const isVisible = featureFlagResult && permissionResult && navItemsResult;
    if (isVisible && !this.hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isVisible && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
  }

  private checkFeatureFlagStrategy(flag: EFeatureFlags) {
    return this.featureFlagService.evaluate(flag);
  }

  private checkPermissionStrategy(key: EPermissionKeys) {
    return this.permissionsService.evaluate(key);
  }
}
